let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jVOOe")).then(() => parcelRequire('fy2oQ'));